<template>
    <LexinKeyboardLangContent :layout_content="getLayout()" :lang_header='getHeader()' @add-to-search="addToSearchInput"></LexinKeyboardLangContent>
</template>
<script>

import LexinKeyboardLangContent from "@/components/LexinKeyboardLangContent.vue";

export default {
    props: [],
    components: {
        LexinKeyboardLangContent
    },

    methods: {
        getHeader(){
            return this.$t('message.keyboard-persian');
        },
        getLayout() {
            let layout = {

                default: [
                    '\u0634 \u0633 \u0698 \u0632 \u0631 \u0630 \u062f \u062e \u062d \u0686 \u062c \u062b \u062a \u067e \u0628 \u0622 \u0627',
                    '\u06cc \u0647 \u0648 \u0646 \u0645 \u0644 \u06af \u06a9 \u0642 \u0641 \u063a \u0639 \u0638 \u0637 \u0636 \u0635',
                    '\u0621 \u0626 \u0624 \u0623 \u064a \u0647\u0654',
                    '\u200c \u0640',
                    '\u064e \u064b \u064f \u0651 \u0652 \u0650',
                ],
                shift: []
            };

            return layout;
        },

        addToSearchInput(value) {
            this.$emit('add-to-search', value);
        }
    }
}
</script>
